import React, {FC} from "react";
import {View, useLocalStorage, Box} from "@unibuddy/patron";
import {useHistory} from "react-router";
import {useEmailInvite} from "ubcommunity-shared/src/Auth/EmailInviteProvider/EmailInviteProvider";
import {VerifyEmailForm} from "./VerifyEmailForm";
import {StepIndicator} from "../Signup/StepIndicator";

export const VerifyEmail: FC = () => {
    const {push} = useHistory();
    const {resetEmailInvite} = useEmailInvite();
    // we check local storage to see if user came from the invite page and signed up
    const [inviteId] = useLocalStorage("community-invite-id.v1");

    const onSuccess = () => {
        if (inviteId) push(`/invite/${inviteId}`);
        resetEmailInvite();
    };

    return (
        <View flex="1">
            <Box paddingTop="xlarge">
                <StepIndicator.BarIndicator currentStep={2} totalSteps={2} />
            </Box>
            <VerifyEmailForm onSuccess={onSuccess} />
        </View>
    );
};
